import 'css-chunk:src/app/containers/Home/ClientsView/ClientDetailView/ContentFields/ContentFieldDrawer/ContentFieldDrawer.scss';export default {
  "contentFieldsDrawer": "_contentFieldsDrawer_867p5_1",
  "optionContainer": "_optionContainer_867p5_13",
  "footer": "_footer_867p5_17"
};